import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue";
const _hoisted_1 = { key: 1 };
const _hoisted_2 = { key: 2 };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_IconSwitcher = _resolveComponent("IconSwitcher");
    const _component_FormSelect = _resolveComponent("FormSelect");
    const _component_ColorSchemeSelect = _resolveComponent("ColorSchemeSelect");
    const _component_Section = _resolveComponent("Section");
    return (_openBlock(), _createBlock(_component_Section, {
        level: 2,
        title: _ctx.titleToUse
    }, {
        afterTitle: _withCtx(() => [
            _createVNode(_component_IconSwitcher, {
                useFirst: _ctx.eyeUseFirst,
                iconID1: ['far', 'eye'],
                iconID2: ['far', 'eye-slash'],
                icon2Style: { color: 'lightgray' },
                width: 24,
                onClick: _ctx.onEyeClick,
                clickable: true,
                title: _ctx.eyeTitle,
                tipPlacement: "left"
            }, null, 8, ["useFirst", "onClick", "title"])
        ]),
        default: _withCtx(() => [
            _createVNode(_component_FormSelect, {
                id: 'atoms-' + _ctx.controlSuffix,
                modelValue: _ctx.atomsOption,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.atomsOption) = $event)),
                options: _ctx.atomsStyleOptions,
                onOnChange: _cache[1] || (_cache[1] = ($event) => (_ctx.updateMolecules(_ctx.atomsOption)))
            }, null, 8, ["id", "modelValue", "options"]),
            (_ctx.atomsOption !== 'atoms-hidden')
                ? (_openBlock(), _createBlock(_component_ColorSchemeSelect, {
                    key: 0,
                    modelValue: _ctx.selAndStyleToUse,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.selAndStyleToUse) = $event)),
                    repName: _ctx.atomsOption,
                    molType: _ctx.molType,
                    idContext: _ctx.controlSuffix,
                    onOnChange: _cache[3] || (_cache[3] = ($event) => (_ctx.updateMolecules(_ctx.atomsOption)))
                }, null, 8, ["modelValue", "repName", "molType", "idContext"]))
                : _createCommentVNode("", true),
            (_ctx.molType === 'protein')
                ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
                    _createVNode(_component_FormSelect, {
                        id: 'protein-' + _ctx.controlSuffix,
                        modelValue: _ctx.backboneOption,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.backboneOption) = $event)),
                        options: _ctx.proteinStyleOptions,
                        onOnChange: _cache[5] || (_cache[5] = ($event) => (_ctx.updateMolecules(_ctx.backboneOption)))
                    }, null, 8, ["id", "modelValue", "options"]),
                    (_ctx.backboneOption !== 'backbone-hidden')
                        ? (_openBlock(), _createBlock(_component_ColorSchemeSelect, {
                            key: 0,
                            modelValue: _ctx.selAndStyleToUse,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.selAndStyleToUse) = $event)),
                            repName: _ctx.backboneOption,
                            molType: _ctx.molType,
                            idContext: _ctx.controlSuffix,
                            onOnChange: _cache[7] || (_cache[7] = ($event) => (_ctx.updateMolecules(_ctx.backboneOption)))
                        }, null, 8, ["modelValue", "repName", "molType", "idContext"]))
                        : _createCommentVNode("", true)
                ]))
                : _createCommentVNode("", true),
            (_ctx.molType !== 'metal')
                ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
                    _createVNode(_component_FormSelect, {
                        id: 'surface-' + _ctx.controlSuffix,
                        modelValue: _ctx.surfaceOption,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_ctx.surfaceOption) = $event)),
                        options: _ctx.metalStyleOptions,
                        onOnChange: _cache[9] || (_cache[9] = ($event) => (_ctx.updateMolecules(_ctx.surfaceOption)))
                    }, null, 8, ["id", "modelValue", "options"]),
                    (_ctx.surfaceOption !== 'surface-hidden')
                        ? (_openBlock(), _createBlock(_component_ColorSchemeSelect, {
                            key: 0,
                            modelValue: _ctx.selAndStyleToUse,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((_ctx.selAndStyleToUse) = $event)),
                            repName: _ctx.surfaceOption,
                            molType: _ctx.molType,
                            idContext: _ctx.controlSuffix,
                            onOnChange: _cache[11] || (_cache[11] = ($event) => (_ctx.updateMolecules(_ctx.surfaceOption)))
                        }, null, 8, ["modelValue", "repName", "molType", "idContext"]))
                        : _createCommentVNode("", true)
                ]))
                : _createCommentVNode("", true)
        ]),
        _: 1
    }, 8, ["title"]));
}
